export type HttpHeaders = {
  readonly [key: string]: string;
};

export type RequestConfig = {
  headers: HttpHeaders;
};

export enum HttpMethod {
  DELETE = 'DELETE',
  GET = 'GET',
  HEAD = 'HEAD',
  OPTIONS = 'OPTIONS',
  PATCH = 'PATCH',
  POST = 'POST',
  PUT = 'PUT',
}
